import { Session } from '@ais-ui/auth';

export const displayMarks = async (
  session: Session,
  sessionUuid: string,
  colorCode: string,
  enableMark: boolean
): Promise<void> => {
  await session.request('displayMarks', {
    sessionUuid,
    colorCode,
    enableMark,
  });
};
